import React, { useContext, useEffect, useState } from 'react';
import GlobalConfig from '../context/GlobalConfig';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import Footer from '../components/Footer';
import Head from './Head';
import { languageData } from '../constants/languageData';
import JourneyConfig from '../context/JourneyConfig';
import { statusesWithoutReview } from '../constants/statuses';
import { useParams } from 'react-router-dom';
import RenderSvg from '../components/RenderSvg';


function PhoneSession({ stepperFunc, stepHistory }) {

  const { config } = useContext(GlobalConfig);
  const { journey, getJourney } = useContext(JourneyConfig);
  const [btnClick, setBtnClick] = useState(false);
  const { journeyId } = useParams();
  const language = sessionStorage.getItem("language") ?? "en";
  const { branding } = config ?? {};
  const color = config?.branding?.accentColor;
  const [journeyUpdated, setJourneyUpdated] = useState(false);

const continueJourney = async (e) => {
  e.preventDefault();

  // Fetch the updated journey
  await getJourney(journeyId, true);

  // Trigger effect when journey is updated
  setJourneyUpdated(true);
};

useEffect(() => {
  sessionStorage.setItem("isContinuedOnMobile", true)
  sessionStorage.setItem("nonImportantStep", true)
}, []);

useEffect(() => {
  if (journeyUpdated) {
    stepperFunc(journey?.currentJourneyState?.currentStep ?? stepHistory[stepHistory.length - 1]);
    setJourneyUpdated(false); // Reset flag
  }
}, [journey, journeyUpdated]);

  // const continueJourney = async (e) => {
  //   e.preventDefault();

  //   // Fetch the updated journey
  //   await getJourney(journeyId, true);
  
  //   // Call stepperFunc after journey has been updated
  //   alert('Here is the problem')
  //   alert(journey?.currentStep)
  //   stepperFunc(journey?.currentStep ?? stepHistory[stepHistory.length - 1]);
  // };

  // useEffect(() => {
  //   if (btnClick) {
  //     stepperFunc(journey?.currentStep ?? stepHistory[stepHistory.length - 1])
  //   }
  // }, [journey, btnClick])

  return (
    <>
      <Head style={{ zIndex: '100' }} stepperFunc={stepperFunc} showMobileFlow={false} showLanguages={false} showHelp={false}/>
      <div className="bg-[#F8F9FA] absolute top-0 left-0 h-[100%] w-full md:hidden z-0"></div>
      <div className="flex flex-col md:flex-row items-center" >

        <div className="md:flex-grow flex flex-row justify-center items-center bg-[#F8F9FA] md:rounded-[10px] md:h-[500px] md:w-[440px] md:p-20 mt-[8rem] mb-[8rem] w-full relative md:mt-0 md:mb-0 " >
          <RenderSvg config={config} id={"phoneSession"} svgType={"phoneSession"} />
        </div>

        <div
          className="md:h-[500px] md:w-[400px] h-full w-full flex flex-col pl-4 md:pr-12 pr-4 pt-8 md:pb-0 pb-8 justify-between bg-white rounded-t-[30px] shadow-4xl md:rounded-none md:shadow-white"
          style={{ fontFamily: 'Inter, sans-serif', zIndex: '1' }} >

          <div className="flex flex-col">
            <div
              className="text-[18px] md:text-[28px] text-center md:text-left font-semibold text-[#000000]"
            >
              {languageData[language]?.phoneSession?.heading}
            </div>
            <div
              className="mt-3 text-[12px] md:text-[16px] text-center md:text-left font-semibold text-[#656565] md:mb-48 mb-12"
            >
              {languageData[language]?.phoneSession?.subheading}
            </div>
          </div>

          <div className="flex flex-col justify-center items-center md:mt-8">
            <button onClick={(e) => continueJourney(e)} className="flex flex-row items-center text-[14px] justify-center gap-4 w-full text-white py-4 px-4 rounded"
              style={{ backgroundColor: color }} >
              {languageData[language]?.phoneSession?.button}
              <ArrowRightIcon className="h-5 w-5" />
            </button>
          </div>
          <Footer />
        </div>
      </div>
    </>

  )
}

export default PhoneSession;